
/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useRef, useEffect, useState, useMemo } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftAvatar from "components/SoftAvatar";
import SoftTypography from "components/SoftTypography";

import Map from "nextus/Maps/Map";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Collapse } from '@mui/material';
import Card from "@mui/material/Card";

import { Route, Link, Routes, useLocation, useNavigate, useMatch } from 'react-router-dom';
import moment from "moment";
import { getUserAccessLevel } from "helper/user";
import { useSoftUIController } from "context";

function GroupCard({ group, subgroup, user_role = "viewer" }) {
  const navigate = useNavigate();

  const [controller, dispatch] = useSoftUIController();
  const { deviceStyle } = controller;

  const mapbox_settings = {
    style: 'mapbox://styles/harrymontano/cm01omrnz000u01omf2uegk93?optimize=true',
    zoom: 17,
    interactive: deviceStyle == 'desktop'
  }

  const onEventClick = function (subgroup) {
    let path = '/groups/' + subgroup.group_id;
    navigate(path);
  }

  if (!subgroup.all_updated) {
    var polygon_colour = "#ff667c";
  }
  else if (subgroup.devices_monitored > 0 && getUserAccessLevel(user_role, 'technician')) {
    var polygon_colour = "#edaa00";
  }
  else {
    var polygon_colour = "#58ba2d";
  }

  return (
    <Card onClick={() => onEventClick(subgroup)}>
      <SoftBox p={2}>
        <SoftBox display="flex" alignItems="center">
          <SoftBox lineHeight={0}>
            <SoftBox mb={1} lineHeight={0}>
              <SoftTypography variant="h6" textTransform="capitalize" fontWeight="medium">
                {subgroup.name}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </SoftBox>
        <SoftBox display='flex' flexDirection='row' justifyContent='space-between'>
          <SoftBox lineHeight={1} mb={2}>
            {subgroup.devices.length == 1 ? (
              <SoftTypography variant="button" fontWeight="regular" color="text">
                {subgroup.devices.length + " Device"}
              </SoftTypography>
            ) : (
              <SoftTypography variant="button" fontWeight="regular" color="text">
                {subgroup.devices.length + " Devices"}
              </SoftTypography>
            )}
          </SoftBox>
        </SoftBox>
        <Card sx={{ height: '200px' }} onClick={(e) => { e.stopPropagation() }}>
          <Map selected_group={subgroup} parent_group={group} colour={polygon_colour} settings={mapbox_settings} padding={30} />
        </Card>
      </SoftBox>
    </Card>
  );

}

// Typechecking props for the GroupCard
GroupCard.propTypes = {
  group: PropTypes.object,
  subgroup: PropTypes.object,
  user_role: PropTypes.string
};

export default GroupCard;
